import React from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";

const AssignModel = (props) => {
  const { register, handleSubmit } = useForm({
    mode: "onChange",
  });

  return (
    <div>
      <Modal
        show={props.partnerCodeModal}
        onHide={() => {
          props.setPartnerCodeModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Enter Partner Code</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            <form
              id="partner-code-form"
              onSubmit={handleSubmit((value) => {
                props.applyServiceApiCall(props.applyServiceUrl, value);
                props.setPartnerCodeModal(false);
              })}
            >
              {" "}
              <div className="">
                Partner Code: (if any)
                <input
                  className="form-control"
                  id="referralCode"
                  type="text"
                  {...register("referralCode")}
                ></input>
              </div>
            </form>
          }
        </Modal.Body>
        <Modal.Footer>
          <button
            className="normal-button px-3 py-2 "
            form="partner-code-form"
            type="submit"
          >
            Submit
          </button>
          {/* <button
            className="normal-button px-3 py-2 "
            form="partner-code-form"
            type="submit"
          >
            Submit Without Code
          </button> */}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AssignModel;
